import React from 'react';
import God from '@this/components/god/god';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createTheme } from '@this/constants/themes';
import ErrorBoundary from '@this/shared/error_boundary/error_boundary';
import UserSignIn from '@this/components/user_signin';
import useApi from '@this/shared/hooks/use_api';
import { ConfirmModalContainer } from '@this/shared/ui/feedbacks/modal/confirm_modal';
import { AITThemeProvider } from '@this/shared/ui/theme';

export const GodRoot = () => {
  const { data, isLoading } = useApi<{ service_id: number; me: any }>('/god/gods/current');
  const serviceId = data?.service_id ?? 1;
  const theme = createTheme(serviceId);

  if (isLoading) {
    return null;
  }

  return (
    <ErrorBoundary>
      <AITThemeProvider theme={theme}>
        <ConfirmModalContainer>
          <BrowserRouter>
            <Switch>
              <Route
                exact
                path="/gods/sign_in"
                render={props => <UserSignIn serviceId={serviceId} {...props} />}
              />
              <Route path="/god" component={God} />
            </Switch>
          </BrowserRouter>
        </ConfirmModalContainer>
      </AITThemeProvider>
    </ErrorBoundary>
  );
};
